import React from 'react';
import './App.css';

function Footer() {
        console.log("Footer component is rendering...");

    return (
        
        <footer className="footer" style={{ backgroundColor: '#214DA0'}}>
            <div className="footer-content">
                <div className="footer-menu">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/fundamentals">Training Fundamentals</a></li>
                        <li><a href="/life-saving">Life-Saving Rules</a></li>
                        <li><a href="/driving-pro">Driving Safety</a></li>
                         <li><a href="/module-videos">Sample Videos</a></li>
                        <li><a href="/pricing">Prices</a></li>
                    </ul>
                </div>
                <div className="footer-menu">


                  <h3>Purchase</h3>
                    <ul>
                        <li><a href="/pclicense">Purchase PC License</a></li>
                        {/* <li><a href="/vrlicense">Purchase VR License</a></li> */}
                        <li><a href="/gamePlay">Play Game</a></li>
                        
                    </ul>
                </div>

                <div className="footer-menu">
                    <h3>About Us</h3>
                    <ul>
                        <li><a href="/faq">FAQs</a></li>
                        <li><a href="/contact">Contact</a></li>
                        <li><a href="/about">About Virsat</a></li>

                    </ul>
                </div>
                <div className="footer-info">
                    <p>&copy; 2025 Virsat. All Rights Reserved.</p>
                    <p><a href="/">Privacy Policy</a> | <a href="/">Terms of Service</a></p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;